// Design tokens shared by the MUI theme and the CSS variables in index.css.
// Keep both in sync: components may read either `theme.palette` or `var(--token)`.

export type ColorMode = 'light' | 'dark';

export interface AppColorTokens {
  canvas: string;
  surface: string;
  card: string;
  mutedBg: string;
  fg: string;
  muted: string;
  border: string;
  primary: string;
  primary2: string;
  accentBg: string;
  accentFg: string;
  success: string;
  successBg: string;
  warn: string;
  warnBg: string;
  danger: string;
  dangerBg: string;
  bar: string;
}

export const BRAND_GRADIENT = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
export const STRAVA_ORANGE = '#fc4c02';

export const colorTokens: Record<ColorMode, AppColorTokens> = {
  light: {
    canvas: '#ececf0',
    surface: '#fafafa',
    card: '#ffffff',
    mutedBg: '#f4f4f5',
    fg: '#09090b',
    muted: '#71717a',
    border: '#e4e4e7',
    primary: '#5a67d8',
    primary2: '#764ba2',
    accentBg: '#eef0fd',
    accentFg: '#4c51bf',
    success: '#15803d',
    successBg: '#dcfce7',
    warn: '#a16207',
    warnBg: '#fef3c7',
    danger: '#dc2626',
    dangerBg: '#fee2e2',
    bar: '#e0e3fb',
  },
  dark: {
    canvas: '#000000',
    surface: '#09090b',
    card: '#111114',
    mutedBg: '#1c1c20',
    fg: '#fafafa',
    muted: '#a1a1aa',
    border: '#27272a',
    primary: '#8b9cf4',
    primary2: '#764ba2',
    accentBg: 'rgba(102,126,234,.16)',
    accentFg: '#b4bffb',
    success: '#4ade80',
    successBg: 'rgba(34,197,94,.14)',
    warn: '#fbbf24',
    warnBg: 'rgba(251,191,36,.14)',
    danger: '#f87171',
    dangerBg: 'rgba(239,68,68,.15)',
    bar: '#25263a',
  },
};

// Avatar / group-initial tints, cycled by index or by a stable hash of a name.
export const AVATAR_TINTS: Array<{ tint: string; ink: string }> = [
  { tint: '#e0e7ff', ink: '#4338ca' },
  { tint: '#fce7f3', ink: '#be185d' },
  { tint: '#dcfce7', ink: '#15803d' },
  { tint: '#fef3c7', ink: '#b45309' },
  { tint: '#e0f2fe', ink: '#0369a1' },
  { tint: '#f3e8ff', ink: '#7e22ce' },
];
